import React from 'react';
import { MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-bg-footer py-10 text-white" data-id="element-66" data-mp="207t4gfx6vxoq">
      <div className="mx-auto max-w-6xl px-6 sm:px-8" data-id="element-67" data-mp="2071b7br2ec1m">
        <div className="grid gap-8 text-center sm:grid-cols-3 sm:text-left" data-id="element-68" data-mp="2f5d3753hswmg">
          <div data-id="element-69" data-mp="2a5qqcwrktie6">
            <p className="font-heading text-lg font-bold text-naranja" data-id="element-70" data-mp="2a579ljdnx01q">Sesión en Mano</p>
          </div>
          <div className="flex flex-col gap-2 text-sm text-white/80 sm:items-center" data-id="element-71" data-mp="1mfmp2w1v1uqc">
            <span data-id="element-72" data-mp="1hhbg0nje3o96">Política de privacidad</span>
            <span data-id="element-73" data-mp="1himhuht9ylxn">Términos</span>
            <span data-id="element-74" data-mp="1hf8f38gp8apo">Contacto</span>
          </div>
          <div className="flex flex-col gap-2 text-sm sm:items-end" data-id="element-75" data-mp="1w70shewxneor">
            <a href="mailto:manualeslistos@gmail.com" className="flex items-center gap-1.5 text-azul hover:underline" data-id="element-76" data-mp="1rfisat2qhi4u">
              <MailIcon size={14} data-id="element-77" data-mp="13ova9ez3tc4k" />
              manualeslistos@gmail.com
            </a>
          </div>
        </div>

        <p className="mt-8 text-center text-xs text-white/60" data-id="element-78" data-mp="yps9w7u2ju2x">
          Balonmano Pro 360 © {new Date().getFullYear()}. Todos los derechos reservados. · Hecho con ❤️ para
          entrenadores.
        </p>
      </div>
    </footer>;
}